module.exports = __webpack_public_path__ + "img/SaveAllOutlined.6cf106e4.svg";